import type React from 'react';
import { useTranslation } from 'react-i18next';

import type { ApiError, ProblemDetailsSchema } from '@/js/libs/api';
import { Error as BaseErrorComponent } from '@/js/libs/error-boundary';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';

import { getErrorMessage } from 'src/hooks/useRequestErrorNotification.ts';

type ErrorContentProps = { title: React.ReactNode; error?: never } | { error?: ApiError<typeof ProblemDetailsSchema>; title?: never };

type ErrorComponentProps = ErrorContentProps & {
  pending?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reFetch?: (...args: any[]) => any;
};

const ErrorComponent: React.FC<ErrorComponentProps> = ({ title, error, reFetch, pending = false }) => {
  const [t] = useTranslation(['backend', 'common', 'components']);

  const errorTitle = error && !error.response ? t('messages:NETWORK_ERROR') : getErrorMessage(error?.response, t);

  const handleRetryClick = useCallbackRef(() => reFetch?.());

  return (
    <BaseErrorComponent title={title ?? errorTitle} onRetryClick={handleRetryClick} pending={pending} retryLabel={t('components:RETRY')} />
  );
};

export default ErrorComponent;
